import React from "react";

const TeamCard = (props) => {
  return (
    <>
      <div class="w-6/12 lg:w-2/12 mb-6 px-2 sm:px-6 lg:px-4">
        <div class="flex flex-col">
          <a href="/" class="mx-auto">
            <img
              class=" hover:drop-shadow-xl transition-all duration-200 delay-100"
              src={props.img}
              alt="team_img"
            />
          </a>
          <div class="text-center mt-2">
            <h1 class="text-gray-900 text-md font-bold mb-1">{props.name}</h1>
            <div class="text-gray-700 font-light mb-2 text-sm">
              {props.position}
            </div>
            <div class="flex flex-row justify-center">
              <a
                href={props.linkedin}
                class="flex rounded-full hover:bg-indigo-50 h-10 w-10"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-linkedin text-indigo-500 mx-auto mt-2 opacity-50 hover:opacity-100 transition-opacity duration-300"
                  viewBox="0 0 16 16"
                >
                  <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamCard;
